import React from 'react'
import styled from "styled-components";
import ShopGalleryItem from './ShopGalleryItem';

// UTILS
import { device } from "../../utils";


// ~~~~ STYLING
const ShopGalleryWrap = styled.div`
  position: relative;
  width: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media ${device.md} {

  }

  @media ${device.xl} {
    justify-content: space-around;
  }
`;


class ShopGallery extends React.Component {
  // PREVENTS SHOP RERENDERING EVERY TIME THE NAV MENU IS OPEN
  // WHY? Context is causing everything to update, so we're preventing that for the most part here
  shouldComponentUpdate(prevProps) {
    if (prevProps.isMenuOpen !== this.props.isMenuOpen) {
      return false;
    }
    return true;
  }



  render() {
    // FILTER : state lives in context (buttons render in the header) and
    // arrives as a prop via ContentPanel
    const { shopifyProducts, shopFilter } = this.props;
    let filteredProducts = shopifyProducts;


    // FILTER THE LIST OF PRODUCTS FROM QUICK FILTER CHOICES
    if ( !!shopifyProducts && shopifyProducts.length > 0 ) {
      // APPAREL FILTER
      if (!!shopFilter && shopFilter === 'apparel' ) {
        filteredProducts = filteredProducts.filter(item => item.product_type === "Gear")
      }

      // NEON FILTER
      if (!!shopFilter && shopFilter === 'neon' ) {
        filteredProducts = filteredProducts.filter(item => item.product_type !== "Gear")
      }
    }


// ~~~~ COMPONENT BODY
    return (
      <ShopGalleryWrap>
        {( filteredProducts.length > 0 ) &&
          filteredProducts.map(product => (
            <ShopGalleryItem key={product.id} product={product} />
          ))
        }
      </ShopGalleryWrap>
    )
  }
};

export default ShopGallery;
